import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,

}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function AreaResponsavel() {
  const utils = require('../../../utils/index');
  const user = utils.getUser();
  const navigate = useNavigate();
  
  return (
    <div className="w-75 d-flex justify-content-center align-items-center mx-auto my-auto" style={{height:'90vh'}}>
      <MDBCard className='bg-dark w-100 p-5' style={{minWidth:'350px'}}>
        <MDBCardBody className='bg-dark w-100'>
          <MDBCardTitle className='text-white'>Bem vindo, {utils.decideName(user)}</MDBCardTitle>
          <MDBCardText className='text-white'>
            O que veio fazer?
          </MDBCardText>
          <div className="d-grid gap-3  w-100">
            <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white' 
              disabled={user.tipouser != 3}
              onClick={() => {
                navigate("/criar-responsavel-temporario")
              }}
              >Criar responsavel</MDBBtn>
            <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white'
              onClick={() => {
                navigate("/listar-responsavel-temporario")
              }} 
              >Listar responsaveis</MDBBtn>
              <MDBBtn 
              className='btn-home w-100 mt-4'
              size='sm'
              outline 
              color='white' 
              onClick={() => {
                navigate("/home")
              }}
              >Voltar</MDBBtn>
          </div>
        </MDBCardBody>
        
      </MDBCard>
    </div>
  );
}

export default AreaResponsavel;